/* eslint-disable max-lines */
(function (app, core, common) {
    'use strict';

    const TEMPLATES = {
        FIXTURES_LIST: 'fixtures.fixture-list',
        FIXTURES_TEAM_A: 'fixtures.fixture-team-a',
        FIXTURES_TEAM_B: 'fixtures.fixture-team-b',
        FIXTURES_SCORE: 'fixtures.fixture-score',
        TICKER_DATE: 'fixtures.ticker-date'
    };

    const MILLISECONDS = {
        POINT_THREE_SECONDS: 300,
        THIRTY_SECONDS: 30000,
        SIX_HOURS: 216000000
    };

    const STATUS = {
        UPCOMING: 'U',
        LIVE: 'L',
        FIRST_HALF: 'L1',
        SECOND_HALF: 'L2',
        OVERTIME_FIRST_HALF: 'L3',
        OVERTIME_SECOND_HALF: 'L4',
        HALF_TIME: 'LHT',
        FULL_TIME: 'LFT',
        COMPLETE: 'C',
        POSTPONED: 'UP'
    };

    const MOBILE_BREAKPOINT = window.matchMedia('(max-width: 1025px)');

    // Disable the scroll restoration for the history
    history.scrollRestoration = 'manual';

    app.Matches = function (widget) {
        const _self = this;

        _self.container = widget;
        _self.fixtureList = _self.container.querySelector('.js-fixture-list');
        _self.nofixtureList = _self.container.querySelector('.js-no-fixtures');
        _self.fixtureTabs = _self.container.querySelector('.js-fixture-tabs');
        _self.genderTabs = _self.container.querySelector('.js-gender-tabs');
        _self.filtersTrigger = _self.container.querySelector(
            '.js-open-filter-sidebar'
        );
        _self.genderTab = _self.container.querySelectorAll('.js-gender-tab');
        _self.viewStandingsCta =
            _self.container.querySelector('.js-view-standings');
        _self.kickOffInfo = _self.container.querySelector('.js-ko-info');
        _self.loader = document.querySelector('.isLoading');
        _self.fixtureModal = document.querySelector('.js-fixture-modal');
        _self.filterSidebar = document.querySelector('.js-fixtures-sidebar');
        _self.filterTeamList = _self.filterSidebar.querySelector(
            '.js-fixtures-sidebar-team-list'
        );
        _self.removeTeamsCta = _self.filterSidebar.querySelector(
            '.js-remove-teams-from-filters'
        );
        _self.closeSiderbarBtn =
            _self.filterSidebar.querySelector('.js-close-sidebar');
        _self.numTeamsIndicator =
            _self.filterSidebar.querySelector('.js-num-teams');
        _self.clearFiltersCta =
            _self.filterSidebar.querySelector('.js-clear-filters');
        _self.applyFiltersCta =
            _self.filterSidebar.querySelector('.js-apply-filters');

        _self.mensId = _self.container.dataset.men;
        _self.womensId = _self.container.dataset.women;
        _self.eventCode = _self.container.dataset.event;
        _self.pitchOneName = _self.container.dataset.pitchOneName || '';
        _self.events = {
            renderedCards: [],
            renderedSubs: [],
            renderedScoring: [],
            renderedEvents: [],
            renderedKoTape: [],
            renderedHtTape: [],
            renderedFtTape: []
        };

        // Fetch the fixtures for the tournement IDs
        _self.getFixtures();

        // Set the initial state of the filter options
        _self.filterOptions = {
            countries: []
        };

        // Set the initial state of the active filters
        _self.appliedFilters = {
            gender: 'ALL',
            countries: []
        };

        // Set the temporary state of the filter sidebar
        _self.sidebarTempFilters = {
            gender: 'ALL',
            countries: []
        };

        // Set the initial state of the filtered matches
        _self.filteredMatches = [];
    };

    /**
     * Show the loading UI
     */
    app.Matches.prototype.showLoader = function () {
        const _self = this;

        core.style.removeClass(_self.loader, 'u-hide');
    };

    /**
     * Hide the loading UI
     */
    app.Matches.prototype.hideLoader = function () {
        const _self = this;

        core.style.addClass(_self.loader, 'u-hide');
    };

    app.Matches.prototype.getFixtures = async function () {
        const _self = this;

        _self.showLoader();
        const params = { language: app.language };
        const urls = [
            common.endpoints.rugby.event.schedule(_self.mensId, params),
            common.endpoints.rugby.event.schedule(_self.womensId, params)
        ];
        const menFetch = fetch(urls[0]).then((response) => response.json());
        const womenFetch = fetch(urls[1]).then((response) => response.json());

        const [menRes, womenRes] = await Promise.all([menFetch, womenFetch]);

        // If there are no matches, show the no fixtures message
        if (!menRes.matches && !womenRes.matches) {
            _self.showNoFixturesMsg();
            return;
        }

        // Merge the two match arrays
        const mergeMatches = [...menRes.matches, ...womenRes.matches];

        // If there are no matches, show the no fixtures message
        if (mergeMatches.length === 0) {
            _self.showNoFixturesMsg();
            return;
        }

        // Sort the matches by date and make available in the class
        _self.matches = mergeMatches.sort((a, b) => {
            if (a.time.millis < b.time.millis) {
                return -1;
            }
            if (a.time.millis > b.time.millis) {
                return 1;
            }
            return 0;
        });

        _self.populateFilterCountries();
        _self.setSidebarListeners();

        // As an initial state, show all matches
        _self.filteredMatches = _self.matches;

        // Check if the event is live, upcoming or completed
        _self.upcoming = _self.matches[0].status === STATUS.UPCOMING;
        _self.completed =
            _self.matches[_self.matches.length - 1].status === STATUS.COMPLETE;
        _self.container.dataset.completed = `${_self.completed}`;
        _self.aMatchIsLive = _self.matches.find((match) =>
            match.status.includes(STATUS.LIVE)
        );
        _self.container.dataset.live = `${_self.aMatchIsLive ? true : false}`;

        // Render the match list
        _self.renderFixtures();

        // Construct the match date tab UI
        _self.renderDateTabs();

        // Look to see if there is a match in the URL and open the modal
        const url = window.location.search;
        _self.events = common.openMatchInUrl(url, _self.container, false);

        // Add event listeners
        _self.fixtureListeners();
        _self.matchdayScrollListeners();

        // Unhide the UI
        core.style.removeClass(_self.viewStandingsCta, 'u-hide');
        core.style.removeClass(_self.kickOffInfo, 'u-hide');

        // Set polling events
        _self.polling();

        // Set Listeners on the page scroll to update the active date tab
        _self.scrollEventListeners();
    };

    // Populate the filter sidebar with the countries in the fixtures
    app.Matches.prototype.populateFilterCountries = function () {
        const _self = this;

        _self.matches.forEach((match) => {
            if (match.teams[0].name) {
                _self.filterOptions.countries.push(match.teams[0].name);
            }
            if (match.teams[1].name) {
                _self.filterOptions.countries.push(match.teams[1].name);
            }
        });
        _self.filterOptions.countries = [
            ...new Set(_self.filterOptions.countries)
        ];

        _self.filterOptions.countries = _self.filterOptions.countries.sort();

        // Render the filter options to the sidebar
        _self.filterOptions.countries.forEach((country) => {
            const model = {
                country: country
            };
            _self.filterTeamList.innerHTML += app.templating.render(
                model,
                'fixtures.fixture-filter'
            );
        });

        // Set the number of teams in the filter sidebar
        _self.numTeamsIndicator.innerHTML =
            _self.filterOptions.countries.length;

        // Add event listeners to the filter items
        _self.filterItems =
            _self.filterTeamList.querySelectorAll('.js-filter-item');
        _self.filterItems.forEach((item) => {
            item.addEventListener('click', () => {
                item.classList.toggle('isActive');
                const country = item.dataset.country;
                if (_self.sidebarTempFilters.countries.includes(country)) {
                    _self.sidebarTempFilters.countries =
                        _self.sidebarTempFilters.countries.filter(
                            (c) => c !== country
                        );
                } else {
                    _self.sidebarTempFilters.countries.push(country);
                }
            });
        });

        // Add event listener to the 'All Teams' button to remove any filtered teams
        if (_self.removeTeamsCta) {
            _self.removeTeamsCta.addEventListener('click', () => {
                _self.resetFilterOptionsUI();
                _self.sidebarTempFilters.countries = [];
            });
        }
    };

    // Update the UI to show how many filters are currently active on the filter trigger button
    app.Matches.prototype.updateActiveFiltersNumber = function () {
        const _self = this;

        // Remove the number of active filters from the filter trigger button
        _self.numFiltersApplied = _self.container.querySelector(
            '.js-num-filters-selected'
        );
        if (_self.numFiltersApplied) {
            _self.numFiltersApplied.remove();
        }

        // If there are active filters, update the filter trigger button to show the number of active filters
        if (_self.appliedFilters.countries.length > 0) {
            _self.filtersTrigger.innerHTML += `<span class="fixtures-tabs__num-filters-selected js-num-filters-selected">+${_self.appliedFilters.countries.length}</span>`;
        }
    };

    // Update the UI to remove the active filters from the filter options
    app.Matches.prototype.resetFilterOptionsUI = function () {
        const _self = this;

        _self.filterItems.forEach((item) => {
            item.classList.remove('isActive');
        });
    };

    // Reset sidebar filters state, clear the temp filters set then update the UI to remove all active classes
    app.Matches.prototype.resetSidebarState = function () {
        const _self = this;

        _self.sidebarTempFilters = {
            gender: 'ALL',
            countries: []
        };

        _self.resetFilterOptionsUI();
    };

    // Apply the temporary filters to the active filters
    app.Matches.prototype.applyFilters = function () {
        const _self = this;

        _self.appliedFilters.countries = [
            ..._self.sidebarTempFilters.countries
        ];
    };

    // Populate the temp filters with the applied filters for when the sidebar opens
    app.Matches.prototype.populateTempFilters = function () {
        const _self = this;

        // take the value of the applied filters and assign it to the temp filters
        _self.sidebarTempFilters.countries = [
            ..._self.appliedFilters.countries
        ];

        // Update the UI to show the active filters in the sidebar
        _self.filterItems.forEach((item) => {
            if (
                _self.sidebarTempFilters.countries.includes(
                    item.dataset.country
                )
            ) {
                item.classList.add('isActive');
            }
        });
    };

    // Clear the applied filters
    app.Matches.prototype.clearAppliedFilters = function () {
        const _self = this;

        _self.appliedFilters = {
            gender: 'ALL',
            countries: []
        };
    };

    // Set the event listeners for the filter sidebar
    app.Matches.prototype.setSidebarListeners = function () {
        const _self = this;

        // Add event listeners to the filter sidebar to open the sidebar
        if (_self.filtersTrigger) {
            _self.filtersTrigger.addEventListener('click', () => {
                // Populate the temp filters with the applied filters state
                _self.populateTempFilters();
                // Open the sidebar
                _self.openSidebar();
            });
        }

        // Add event listeners to the filter sidebar to close the sidebar
        if (_self.closeSiderbarBtn) {
            _self.closeSiderbarBtn.addEventListener('click', () => {
                //
                _self.resetSidebarState();
                _self.closeSidebar();
            });
        }

        // Add event listeners to the filter sidebar to clear the filters and close the sidebar
        if (_self.clearFiltersCta) {
            _self.clearFiltersCta.addEventListener('click', () => {
                _self.resetSidebarState();
                _self.clearAppliedFilters();
                _self.closeSidebar();
                _self.filterFixtures();
            });
        }

        // Add event listeners to the filter sidebar to apply the filters and close the sidebar, then update the fixtures and scroll to the most relevant match
        if (_self.applyFiltersCta) {
            _self.applyFiltersCta.addEventListener('click', () => {
                _self.applyFilters();
                _self.resetSidebarState();
                _self.closeSidebar();
                _self.filterFixtures();
            });
        }
    };

    // Open the filter sidebar
    app.Matches.prototype.openSidebar = function () {
        const _self = this;

        core.style.addClass(_self.filterSidebar, 'u-active');
    };

    // Close the filter sidebar
    app.Matches.prototype.closeSidebar = function () {
        const _self = this;

        // Close the filter sidebar
        core.style.removeClass(_self.filterSidebar, 'u-active');

        // Update the number of active filters on the filter trigger button
        _self.updateActiveFiltersNumber();

        // Scroll the team list back to the top
        _self.filterTeamList.parentElement.scrollTop = 0;
    };

    // Scroll the page to the most relevant match
    app.Matches.prototype.scrollPageToReleventMatch = function () {
        const _self = this;

        // If the event is completed, scroll to the last match
        if (_self.completed) {
            const lastMatch = document.querySelector(
                `[data-match-id="${
                    _self.filteredMatches[_self.filteredMatches.length - 1]
                        .matchId
                }"]`
            );
            _self.scrollToMatch(lastMatch);
            return;
        }

        // If there is a live match, scroll to it
        if (_self.aMatchIsLive) {
            const liveMatch = document.querySelector(
                `[data-match-id="${_self.aMatchIsLive.matchId}"]`
            );
            _self.scrollToMatch(liveMatch);
            return;
        }

        // Otherwise Scroll to the next upcoming match...
        const upcomingMatch = document.querySelector(
            `[data-status="${STATUS.UPCOMING}"]`
        );
        _self.scrollToMatch(upcomingMatch);
    };

    app.Matches.prototype.polling = function () {
        const _self = this;

        let now = new Date().getTime();
        if (now > _self.startPolling && now < _self.endPolling) {
            _self.polling = setInterval(() => {
                _self.getUpdates();
            }, MILLISECONDS.THIRTY_SECONDS);
        }
    };

    app.Matches.prototype.getPollingTimeframe = function (match, idx) {
        const _self = this;

        if (idx === 0) {
            _self.startPolling = match.time.millis - MILLISECONDS.SIX_HOURS;
            _self.endPolling = match.time.millis + MILLISECONDS.SIX_HOURS;
            return;
        }

        if (match.time.millis - MILLISECONDS.SIX_HOURS < _self.startPolling) {
            _self.startPolling = match.time.millis - MILLISECONDS.SIX_HOURS;
        } else if (
            match.time.millis + MILLISECONDS.SIX_HOURS >
            _self.endPolling
        ) {
            _self.endPolling = match.time.millis + MILLISECONDS.SIX_HOURS;
        }
    };

    app.Matches.prototype.getUpdates = async function () {
        const _self = this;

        const params = { language: app.language };
        const urls = [
            common.endpoints.rugby.event.schedule(_self.mensId, params),
            common.endpoints.rugby.event.schedule(_self.womensId, params)
        ];
        const menFetch = fetch(urls[0]).then((response) => response.json());
        const womenFetch = fetch(urls[1]).then((response) => response.json());
        const [menRes, womenRes] = await Promise.all([menFetch, womenFetch]);

        if (menRes.matches && womenRes.matches) {
            const mergeMatches = [...menRes.matches, ...womenRes.matches];
            _self.updateFixtureList(mergeMatches);
        }
    };

    app.Matches.prototype.updateFixtureList = async function (mergeMatches) {
        const _self = this;

        mergeMatches.forEach((newDataItem) => {
            const fixtureInfo = document.querySelectorAll('.js-fixture-item');
            fixtureInfo.forEach((templateItem) => {
                if (templateItem.dataset.matchId === newDataItem.matchId) {
                    const teamA = templateItem.querySelector('.js-team-a');
                    const teamB = templateItem.querySelector('.js-team-b');
                    const newTeamA = newDataItem.teams[0].abbreviation || '';
                    const newTeamB = newDataItem.teams[1].abbreviation || '';

                    if (teamA && teamA.dataset.team !== newTeamA) {
                        const model = {
                            abbrv: newTeamA,
                            name: newDataItem.teams[0].name || '',
                            eventCode: _self.eventCode,
                            parentClass: 'fixture-list'
                        };
                        teamA.innerHTML = app.templating.render(
                            model,
                            TEMPLATES.FIXTURES_TEAM_A
                        );
                        teamA.dataset.team = newTeamA;
                    }

                    if (teamB && teamB.dataset.team !== newTeamB) {
                        const model = {
                            abbrv: newTeamB,
                            name: newDataItem.teams[1].name || '',
                            eventCode: _self.eventCode,
                            parentClass: 'fixture-list'
                        };
                        teamB.innerHTML = app.templating.render(
                            model,
                            TEMPLATES.FIXTURES_TEAM_B
                        );
                        teamB.dataset.team = newTeamB;
                    }

                    if (
                        templateItem.dataset.status !== newDataItem.status ||
                        newDataItem.status.includes(STATUS.LIVE)
                    ) {
                        const matchId = newDataItem.matchId || '0';
                        _self.updateScores(matchId, templateItem, mergeMatches);
                    }
                }
            });
        });
    };

    app.Matches.prototype.updateScores = async function (
        matchId,
        templateItem,
        mergeMatches
    ) {
        const _self = this;

        const params = { language: app.language };
        const urls = [
            common.endpoints.rugby.match.summary(matchId, params),
            common.endpoints.rugby.match.timeline(matchId, params)
        ];
        const summary = fetch(urls[0]).then((response) => response.json());
        const timeline = fetch(urls[1]).then((response) => response.json());
        const [summaryRes, timelineRes] = await Promise.all([
            summary,
            timeline
        ]);
        const match = summaryRes.match || [];

        const scores = templateItem.querySelector('.js-scores') || '';
        const versus = templateItem.querySelector('.js-versus') || '';
        const scoreA = templateItem.querySelector('.js-score-a') || '';
        const scoreB = templateItem.querySelector('.js-score-b') || '';

        const scoreChange =
            (scoreA && scoreA.dataset.score !== match.scores[0].toString()) ||
            (scoreB && scoreB.dataset.score !== match.scores[1].toString());
        const statusChange =
            templateItem.dataset.status &&
            templateItem.dataset.status !== match.status;

        const matchStarted =
            match.status !== STATUS.UPCOMING &&
            match.status !== STATUS.POSTPONED;
        if (matchStarted && versus) {
            core.style.addClass(versus, 'u-hide');
        }

        if (scoreChange || statusChange) {
            const model = {
                scoreA: match.scores[0] || '0',
                scoreB: match.scores[1] || '0',
                status: match.status,
                parentClass: 'fixture-list'
            };
            if (scores) {
                scores.innerHTML = app.templating.render(
                    model,
                    TEMPLATES.FIXTURES_SCORE
                );
            }
        }

        if (statusChange) {
            common.updateStatus(templateItem, match, scores);
            _self.completed =
                mergeMatches[mergeMatches.length - 1].status ===
                STATUS.COMPLETE;
            _self.container.dataset.completed = `${_self.completed}`;
            _self.aMatchIsLive = _self.checkForLiveMatch(mergeMatches, match);
            _self.container.dataset.live = `${
                _self.aMatchIsLive ? true : false
            }`;
            common.setFixtureCta(_self.container);
        }

        if (core.style.hasClass(_self.fixtureModal, 'isVisible')) {
            _self.events = new app.MatchPolling(
                match,
                summaryRes,
                timelineRes,
                _self.events
            );
        }
    };

    app.Matches.prototype.checkForLiveMatch = function (mergeMatches, current) {
        let matchIsLive = false;
        mergeMatches.forEach((match) => {
            if (match.status.includes(STATUS.LIVE)) {
                matchIsLive =
                    current.matchId === match.matchId &&
                    !current.status.includes(STATUS.LIVE)
                        ? matchIsLive
                        : true;
            }
        });
        return matchIsLive;
    };

    app.Matches.prototype.showNoFixturesMsg = function () {
        const _self = this;

        _self.hideLoader();
        core.style.removeClass(_self.nofixtureList, 'u-hide');
    };

    app.Matches.prototype.hideNoFixturesMsg = function () {
        const _self = this;

        _self.hideLoader();
        core.style.addClass(_self.nofixtureList, 'u-hide');
    };

    app.Matches.prototype.fixtureListeners = function () {
        const _self = this;

        _self.genderTab.forEach((tab) => {
            tab.addEventListener('click', () => {
                const gender = tab.dataset.gender;

                if (!gender) {
                    return;
                }

                if (gender === 'All') {
                    _self.appliedFilters = {
                        ..._self.appliedFilters,
                        gender: 'ALL'
                    };
                } else {
                    _self.appliedFilters = {
                        ..._self.appliedFilters,
                        gender: gender.toUpperCase()
                    };
                }
                _self.updateGenderTabState();
                _self.filterFixtures();
                _self.checkInViewportMatches();
            });
        });

        core.style.removeClass(_self.fixtureTabs, 'u-hide');
        core.style.removeClass(_self.genderTabs, 'u-hide');
        core.style.removeClass(_self.filtersTrigger, 'u-hide');
    };

    // Filter the fixtures based on the active filters
    app.Matches.prototype.filterFixtures = function () {
        const _self = this;

        // Filter the matches based on the active gender filter
        if (_self.appliedFilters.gender === 'ALL') {
            _self.filteredMatches = _self.matches;
        } else if (_self.appliedFilters.gender === 'WOMEN') {
            _self.filteredMatches = _self.matches.filter((match) => {
                return match.sport === 'WRS';
            });
        } else if (_self.appliedFilters.gender === 'MEN') {
            _self.filteredMatches = _self.matches.filter((match) => {
                return match.sport === 'MRS';
            });
        }

        // Filter the matches based on the active country filter
        if (_self.appliedFilters.countries.length > 0) {
            _self.filteredMatches = _self.filteredMatches.filter((match) => {
                return (
                    _self.appliedFilters.countries.includes(
                        match.teams[0].name
                    ) ||
                    _self.appliedFilters.countries.includes(match.teams[1].name)
                );
            });
        }

        // Render the filtered fixtures
        _self.renderFixtures();
    };

    app.Matches.prototype.matchdayScrollListeners = function () {
        const _self = this;

        // Add click eventlisteners to the matchday tabs in order to scroll the user to the correct matchday
        const tabs = document.querySelectorAll('.js-fixture-tab');
        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                const dataDate = tab.dataset.date;
                let matchDateSelector = `.js-date-tape[data-date-tape="${dataDate}"]`;

                const matchday = document.querySelector(matchDateSelector);
                _self.scrollToMatch(matchday);
            });
        });

        document.addEventListener('scrollToMatch', (evt) => {
            const targetElement = document.querySelector(
                `.js-fixture-item[data-match-id="${evt.detail}"]`
            );
            _self.scrollToMatch(targetElement);
        });
    };

    // Renders the matches currently filtered to the match list container
    app.Matches.prototype.renderFixtures = function () {
        const _self = this;

        // Show the loader
        _self.showLoader();

        // Reset the fixture list constants
        let isFeatured = false;
        let eventCode = _self.eventCode;
        let pitchOneName = _self.pitchOneName;

        let displayDate = '';

        // Clear the fixture list
        _self.fixtureList.innerHTML = '';

        // Loop through the filtered matches and render the match list
        if (Object.keys(this.filteredMatches).length > 0) {
            this.filteredMatches.forEach((match, idx) => {
                // Check to see if this is the first match of the day
                let thisMatchDate = _self.getDateLabel(
                    new Date(match.time.millis)
                );
                // If the date has changed, render a new date tape
                if (displayDate !== thisMatchDate) {
                    displayDate = thisMatchDate;
                    _self.fixtureList.innerHTML += app.templating.render(
                        {
                            eventCode,
                            displayDate: _self.getDateLabel(
                                new Date(match.time.millis)
                            ),
                            dateString: _self.getDate(
                                new Date(match.time.millis)
                            )
                        },
                        TEMPLATES.TICKER_DATE
                    );
                }
                // Get the polling timeframe for the matches and render the fixture in the match list
                _self.getPollingTimeframe(match, idx);
                _self.fixtureList.innerHTML += app.templating.render(
                    { match, isFeatured, eventCode, pitchOneName },
                    TEMPLATES.FIXTURES_LIST
                );
            });
        }

        // Show/hide the no fixtures message based on the number of matches
        if (_self.filteredMatches.length === 0) {
            _self.showNoFixturesMsg();
        } else {
            _self.hideNoFixturesMsg();
        }

        // Hide the loader
        _self.hideLoader();

        // Scroll the page ot the most relevent match
        _self.scrollPageToReleventMatch();

        // Set match listeners
        const fixtureInfo = document.querySelectorAll('.js-fixture-item');
        if (fixtureInfo.length > 0) {
            common.setFixtureCta(_self.container);

            fixtureInfo.forEach((item) => {
                item.addEventListener('click', () => {
                    const matchId = item.dataset.matchId;
                    const refresh = `${window.location.protocol}//${window.location.host}${window.location.pathname}?matchId=${matchId}&tab=timeline`;
                    window.history.pushState({ path: refresh }, '', refresh);

                    _self.events = {
                        renderedCards: [],
                        renderedSubs: [],
                        renderedScoring: [],
                        renderedEvents: [],
                        renderedKoTape: [],
                        renderedHtTape: [],
                        renderedFtTape: []
                    };
                    _self.events = new app.MatchModal(
                        matchId,
                        _self.container,
                        _self.events,
                        false
                    );
                });
            });
        }
    };

    // Update the date tabs to show the updated active tab state - called on page scroll
    app.Matches.prototype.updateDateTabState = function (date) {
        const tabs = document.querySelectorAll('.js-fixture-tab');
        if (tabs.length > 0) {
            tabs.forEach((tab) => {
                core.style.removeClass(tab, 'isActive');
                const dataDate = tab.dataset.date;
                if (date === dataDate) {
                    core.style.addClass(tab, 'isActive');
                }
            });
        }
    };

    // Update the gender tabs to show the updated active tab state
    app.Matches.prototype.updateGenderTabState = function () {
        const _self = this;

        _self.genderTab.forEach((tab) => {
            core.style.removeClass(tab, 'isActive');
            const dataGender = tab.dataset.gender;
            if (_self.appliedFilters.gender === dataGender.toUpperCase()) {
                core.style.addClass(tab, 'isActive');
            }
        });
    };

    // Render the date tabs for the match list
    app.Matches.prototype.renderDateTabs = function () {
        const _self = this;

        const matchDays = new Map();

        // Loop though the matches and add the match date to the map
        _self.matches.forEach((match) => {
            // Add the match date to the map
            matchDays.set(
                _self.getDate(new Date(match.time.millis)),
                _self.getDateLabel(new Date(match.time.millis))
            );
        });

        let matchDaysArray = Array.from(matchDays);
        if (matchDaysArray.length > 0) {
            matchDaysArray.forEach((date) => {
                let tabDate = date[0];
                let tabDateLabel = date[1];
                _self.fixtureTabs.innerHTML += `
                    <li class="fixtures-tabs-item js-fixture-tab" 
                        data-date="${tabDate}">
                        ${tabDateLabel}
                    </li>
                `;
            });
        }
    };

    // Return a date string for a given date
    app.Matches.prototype.getDate = function (date) {
        return moment(date).format('YYYY-MM-DD');
    };

    // Return a display date string for a given date
    app.Matches.prototype.getDateLabel = function (date) {
        let currentDate = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate()
        );

        if (app.language !== 'ja') {
            currentDate = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() + 1
            );
        }

        const allowedChars = '0123456789';
        let daysMonth = '';

        if (app.language === 'ja') {
            let numericDate = '';
            let symbol = '';
            const japaneseDay = currentDate.toLocaleString('ja-JP', {
                day: 'numeric'
            });
            for (let i = 0; i < japaneseDay.length; i++) {
                const char = japaneseDay[i];
                if (allowedChars.includes(char)) {
                    numericDate += char;
                } else {
                    symbol += char;
                }
            }

            daysMonth =
                numericDate +
                symbol +
                ' ' +
                currentDate.toLocaleString('ja-JP', { month: 'short' });
        } else {
            daysMonth =
                currentDate.toLocaleString('default', {
                    day: 'numeric'
                }) -
                1 +
                ' ' +
                currentDate.toLocaleString('default', {
                    month: 'short'
                });
        }
        if (daysMonth[0] === '0') {
            const monthLabel = currentDate.toLocaleString('default', {
                month: 'numeric'
            });
            const yearLabel = currentDate.toLocaleString('default', {
                year: 'numeric'
            });
            const dateLabel = common.getFinalDayOfMonth(monthLabel, yearLabel);
            daysMonth = moment(dateLabel).format('D MMM');
        }

        return daysMonth;
    };

    // Scroll the page to a specific match
    app.Matches.prototype.scrollToMatch = function (targetElement) {
        if (!targetElement) {
            return;
        }

        const yOffset = MOBILE_BREAKPOINT.matches ? -196 : -151; // Numbers based on element height and spacing in the page
        const yScroll =
            targetElement.getBoundingClientRect().top +
            window.scrollY +
            yOffset;

        setTimeout(() => {
            window.scrollTo({ top: yScroll, behavior: 'smooth' });
        }, MILLISECONDS.POINT_THREE_SECONDS);
    };

    // Add event listeners to the window scroll to update the active date tab on scroll
    app.Matches.prototype.scrollEventListeners = function () {
        const _self = this;

        // Add a scroll listener to the window to update the active date tab. Has some event throlling to prevent too many calls
        window.addEventListener('scroll', () => {
            clearTimeout(_self.scrollTimer);
            _self.scrollTimer = setTimeout(() => {
                _self.checkInViewportMatches();
            }, 100);
        });
    };

    // Check if the matches are in the viewport and update the active date tab
    app.Matches.prototype.checkInViewportMatches = function () {
        const _self = this;

        let matchDateSelector = `.js-fixture-item`;

        const matchListEls = document.querySelectorAll(matchDateSelector);

        const matchesInViewport = [];
        matchListEls.forEach((match) => {
            if (_self.isElementInViewport(match)) {
                matchesInViewport.push(match);
            }
        });

        // If there are matches in the viewport, set the active tab (we're using the second match in the viewport as the active date so the nav isnt in the way)
        if (matchesInViewport.length > 0 && matchesInViewport[1]) {
            const match = matchesInViewport[1];
            const matchDate = match.dataset.matchDate;
            _self.updateDateTabState(matchDate);
        }
    };

    // Check if an element is in the viewport
    app.Matches.prototype.isElementInViewport = function (el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
                (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    const widgets = document.querySelectorAll('[data-widget="matches"]');
    [].forEach.call(widgets, (widget) => new app.Matches(widget));
})(PULSE.app, PULSE.core, PULSE.app.common);
